import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'syf-component-library/ui/atoms/Button';
import MessageBox from 'syf-component-library/ui/patterns/MessageBox';
import Inset from 'syf-component-library/ui/spacing/Inset';
import Body from 'syf-component-library/ui/typography/Body';
import { DATA_ANALYTICS, DATA_REASON, DATA_TYPE } from '../../../const/analytics';
import { FAL_TIMES } from '../../../const/iconProps';
import { colors } from '../../../defaultTheme';
const CloseIconWrapper = styled.div `
  position: absolute;
  top: 0;
  right: 0;
`;
const CloseIcon = styled(FontAwesomeIcon) `
  cursor: pointer;
  color: ${colors.black};
  font-size: 1.5em;
`;
const ErrorMessageBox = styled(MessageBox) `
  position: relative;
`;
const PaymentMethodErrorMessageBox = ({ errorMessage, leftIcon, handleClose }) => {
    return (_jsxs(ErrorMessageBox, Object.assign({ icon: _jsx(FontAwesomeIcon, { icon: leftIcon, size: "lg" }), role: "alertdialog", type: "error" }, { children: [_jsx(Inset, Object.assign({ right: "base", tabIndex: 0 }, { children: _jsx(Body, { children: errorMessage }) })), _jsx(CloseIconWrapper, { children: _jsx(Button, Object.assign({ buttonType: "text", "data-analytics": DATA_ANALYTICS.CLICK_TRACKING_EVENT, "data-reason": DATA_REASON.MANAGE_PAYMENT_METHODS.X_BUTTON_BODY, "data-testid": "close-delete-message-box", "data-type": DATA_TYPE.MAKE_A_PAYMENT, onClick: handleClose }, { children: _jsx(CloseIcon, { "aria-hidden": true, icon: FAL_TIMES }) })) })] })));
};
export default PaymentMethodErrorMessageBox;
